module.exports = __webpack_public_path__ + "img/broadcastIcon.056233cd.png";